import $ from 'jquery';

class RestorationSolutionsSnapshot {
  constructor() {
    this.snapshot = $('.js-rss-snapshot');

    if (!this.snapshot.length) {
      return;
    }

    this.pageUrl = this.snapshot.data('page-url');

    this.createIframe();
  }

  createIframe() {
    if (this.pageUrl) {
      this.iframe = $('<iframe></iframe', {
        id: this.snapshot.parent().attr('id'),
        width: '100%',
        frameborder: '0',
        scrolling: 'no',
        marginheight: '0',
        marginwidth: '0',
        src: this.pageUrl,
        css: {
          display: 'none',
        },
      });

      this.snapshot.html(this.iframe);
      this.animationStarted = false;

      this.iframe.hide().on('load', () => {
        this.prepareIframeForDisplay();
        this.iframe.show();

        $(window).on('load scroll', () => {
          const topOffset = $(window).scrollTop();
          // const windowHeight = $(window).height();

          if (this.snapshot.offset().top <= topOffset + 300) {
            if (this.animationStarted) {
              return;
            }

            this.scrollIframe();
            this.animationStarted = true;
          }
        });

        this.iframeContents.on('scroll', e => {
          const html = $(e.target).find('html');

          if (html.scrollTop() === this.iframeScrollLimit) {
            this.snapshot.stop().animate(
              {
                opacity: 0,
              },
              500,
              () => {
                html.scrollTop(0);
                this.scrollIframe();
                this.snapshot.stop().animate({ opacity: 1 }, 200);
              },
            );
          }
        });
      });
    }
  }

  prepareIframeForDisplay() {
    this.iframeContents = this.iframe.contents();

    const header = this.iframeContents.find('.c-header');
    const content = this.iframeContents.find('.c-page-container');
    const pageContent = this.iframeContents.find(
      '.c-block-restoration-solutions',
    );

    const adminBar = this.iframeContents.find('#wpadminbar');

    if (adminBar.length) {
      adminBar.remove();
    }

    if (header.length && content.length && pageContent.length) {
      header.remove();
      this.iframeContents
        .find('body')
        .css({ overflow: 'hidden', padding: 15, height: '100%' });
      pageContent
        .find('.c-brs-stage')
        .first()
        .find('.c-brs-stage__boxes')
        .first()
        .find('.js-brs-box')
        .addClass('is-in-view');
      pageContent.find('.c-brs-content').css({ 'margin-bottom': 0 });
      content.html(pageContent);
      this.snapshot.css({ opacity: 1 });
    }
  }

  scrollIframe() {
    const iframeHeight = this.snapshot.height();
    const iframeContentsHeight = this.iframeContents.height();
    this.iframeScrollLimit = iframeContentsHeight - iframeHeight;
    const speed = this.snapshot.data('anim-speed') || 30000;

    this.iframeContents
      .find('body, html')
      .stop()
      .animate(
        {
          scrollTop: this.iframeScrollLimit,
        },
        speed,
        'linear',
      );
  }
}

export default new RestorationSolutionsSnapshot();



// WEBPACK FOOTER //
// ./src/scripts/modules/restoration-solutions-snapshot.js